var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "scope-select" },
    [
      _c(
        "el-select",
        _vm._g(
          _vm._b(
            {
              key: _vm.language,
              ref: "elSelect",
              attrs: {
                filterable: "",
                size: "small",
                multiple: _vm.isMultiple,
                "reserve-keyword": "",
                placeholder: _vm.placeholderValue,
                clearable: "",
                "filter-method": _vm.filterMethod,
                remote: _vm.isRemote,
                "remote-method": _vm.remoteMethod,
                loading: _vm.loading,
              },
              on: { change: _vm.change, focus: _vm.handleFocus },
              model: {
                value: _vm.content,
                callback: function ($$v) {
                  _vm.content = $$v
                },
                expression: "content",
              },
            },
            "el-select",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        ),
        _vm._l(_vm.filteredScopeList, function (scope) {
          return _c("el-option", {
            key: scope.id,
            attrs: { label: _vm.getOptionLabel(scope), value: scope.id },
          })
        }),
        1
      ),
      _vm.multipleSelectAll
        ? _c(
            "el-button",
            {
              staticStyle: { "vertical-align": "top" },
              attrs: { type: "primary" },
              on: { click: _vm.onClickAll },
            },
            [_vm._v(_vm._s(_vm.$t("riskMonitoring.select_all")))]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }